// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const AppHeader = require('client-v2/common/containers/app-header/component-smart')

function mapStateToProps(state) {
  if (state.router.action === 'search.showDomainPosts') {
    return {}
  }
  return {
    initialSearchHidden: false,
    initialSearchValue: state.query.decoded
  }
}

module.exports = connect(
  mapStateToProps
)(
  AppHeader
)
